document.addEventListener('DOMContentLoaded', function () {
  const galleryItems = document.querySelectorAll('.gallery-item');

  function fadeInOnScroll() {
    galleryItems.forEach(function (item) {
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        item.classList.add('fade-in');
      }
    });
  }

  window.addEventListener('scroll', fadeInOnScroll);
  fadeInOnScroll(); // Initial check on load
});





document.addEventListener('DOMContentLoaded', function () {
  // Get the popup modal
  var popup = document.getElementById("image-popup");
  var popupImg = document.getElementById("popup-img");
  var closeBtn = document.querySelector(".popup .close");
  var prevBtn = document.querySelector(".popup .prev");
  var nextBtn = document.querySelector(".popup .next");
  var currentIndex = 0;
  
  // Get all triggers and image sources
  var triggers = document.querySelectorAll(".popup-trigger");
  var images = Array.from(triggers).map(trigger => trigger.getAttribute("data-image"));

  // Function to show an image in the popup
  function showImage(index) {
    currentIndex = index;
    popupImg.src = images[index];
    popup.style.display = "block";
  }

  // Open popup when clicking on any image link
  triggers.forEach(function (trigger, index) {
    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      showImage(index);
    });
  });

  // Close popup when clicking on the close button
  closeBtn.addEventListener("click", function () {
    popup.style.display = "none";
  });

  // Close popup when clicking outside the image
  popup.addEventListener("click", function (event) {
    if (event.target === popup) {
      popup.style.display = "none";
    }
  });

  // Navigate to the previous image
  prevBtn.addEventListener("click", function () {
    currentIndex = (currentIndex > 0) ? currentIndex - 1 : images.length - 1;
    showImage(currentIndex);
  });

  // Navigate to the next image
  nextBtn.addEventListener("click", function () {
    currentIndex = (currentIndex < images.length - 1) ? currentIndex + 1 : 0;
    showImage(currentIndex);
  });

  // Keyboard navigation support
  document.addEventListener("keydown", function(event) {
    if (popup.style.display === "block") {
      if (event.key === "ArrowLeft") {
        prevBtn.click();
      } else if (event.key === "ArrowRight") {
        nextBtn.click();
      } else if (event.key === "Escape") {
        popup.style.display = "none";
      }
    }
  });
});
